import React, { useEffect, useState, forwardRef, useMemo } from "react";
import Card from "@material-ui/core/Card";
import { Route, Link, useRouteMatch } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { makeStyles } from "@material-ui/core/styles";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ListSubheader from "@material-ui/core/ListSubheader";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Service } from "../../Api";
import ReactHtmlParser from "react-html-parser";
import { connect } from "react-redux";
import { analyticsTagTrigger } from "../../helpers";

const useStyles = makeStyles((theme) => ({
  demo: {
    backgroundColor: theme.palette.background.paper,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "90.33%",
    flexShrink: 0,
  },
}));

const handleChange = async (set, src, marker, key, name, setName, selected) => {
  console.log("handling changues");
  let s = await Service.get(src, (status, fetched) => fetched);
  s !== selected && set(s);
  s !== selected && setName(name);
  s !== selected && marker(key);
};

const ListItemLink = (props) => {
  const {
    icon,
    primary,
    to,
    setSelectedTopic,
    source,
    setListMarker,
    setPrimary,
    keyMarker,
    listLength,
    dark,
  } = props;
  const renderLink = useMemo(
    () =>
      forwardRef((itemProps, ref) => (
        <Link to={to} {...itemProps} innerRef={ref} />
      )),
    [to]
  );
  return (
    <li
      style={{
        border: "solid",
        borderWidth: "1px",
        borderColor: dark ? "#5b5b5b" : "#d0d0d0",
        borderTopStyle: keyMarker > 0 ? "none" : "solid",
        borderBottomLeftRadius: listLength - 1 === keyMarker ? 5 : 0,
        borderBottomRightRadius: listLength - 1 === keyMarker ? 5 : 0,
        borderTopLeftRadius: keyMarker === 0 ? 5 : 0,
        borderTopRightRadius: keyMarker === 0 ? 5 : 0,
      }}
    >
      <ListItem
        button
        component={renderLink}
        onClick={() =>
          handleChange(
            setSelectedTopic,
            source,
            setListMarker,
            to.substring(to.lastIndexOf("/") + 1),
            primary,
            setPrimary
          )
        }
        selected={
          window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1
          ) === to.substring(to.lastIndexOf("/") + 1)
        }
      >
        {!!icon && <ListItemIcon children={icon} />}
        <ListItemText primary={primary} />
      </ListItem>
    </li>
  );
};

const Topic = (props) => {
  const [expanded, setExpanded] = useState(0);
  const { selectedTopic, primaryName, dark } = props;
  const classes = useStyles();
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <div className="px-3">
      <Typography variant="h6">{primaryName}</Typography>
      {Array.isArray(selectedTopic) &&
        selectedTopic.map((q, i) => (
          <div>
            {!!q.mainTitle && (
              <Typography variant="subtitle1" className="my-4">
                {q.mainTitle}
              </Typography>
            )}
            {!!q.expansionPanels &&
              q.expansionPanels.map(({ title, content, tag }, key) => (
                <ExpansionPanel
                  expanded={
                    expanded ===
                    (i !== 0
                      ? selectedTopic[i - 1].expansionPanels.length + key
                      : key)
                  }
                  onChange={handleChange(
                    i !== 0
                      ? selectedTopic[i - 1].expansionPanels.length + key
                      : key
                  )}
                  onClick={() => !!tag && analyticsTagTrigger(tag)}
                  style={{
                    borderRadius: 5,
                    border: "solid",
                    borderColor: dark ? "#525252" : "#e5e5e5",
                    borderWidth: "1px",
                  }}
                >
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    style={{
                      backgroundColor: dark ? "#383838" : "rgba(0, 0, 0, 0.03)",
                      borderRadius: 5,
                      borderBottomWidth: "1px",
                      borderBottomStyle: "none",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      bold
                      className={classes.heading}
                      color={dark ? "light-gray" : "primary"}
                    >
                      {title}
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails style={{}}>
                    <Typography variant="body2" color="textSecondary">
                      {content.includes("<" || ">")
                        ? ReactHtmlParser(content)
                        : content}
                    </Typography>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))}
          </div>
        ))}
    </div>
  );
};

const FileBrowser = (props) => {
  let { path, url } = useRouteMatch();
  const [selectedTopic, setSelectedTopic] = useState([]);
  const [listMarker, setListMarker] = useState("");
  const [primaryName, setPrimary] = useState(null);
  const classes = useStyles();
  const { topics, dark } = props;
  let currentUrl = window.location.href.substring(
    window.location.href.lastIndexOf("/") + 1
  );
  useEffect(() => {
    console.log("chenges");
    let isSelected = !!(Array.isArray(selectedTopic) && selectedTopic.length);
    let requestLoad =
      (!isSelected && currentUrl !== "") || (!isSelected && currentUrl === url);
    let topicFound = topics.find(({ route }) => currentUrl === route);
    !isSelected &&
      !!topicFound &&
      requestLoad &&
      handleChange(
        setSelectedTopic,
        topicFound.source,
        setListMarker,
        topicFound.route,
        topicFound.name,
        setPrimary,
        selectedTopic
      );
  }, []);
  return (
    <Container maxWidth="lg" className="my-3 px-0">
      <Grid container spacing={3}>
        <Grid item md={4} xs={12}>
          <Card>
            <div className={classes.demo}>
              <List dense className="pb-0">
                <ListSubheader>¿Cúal es la temática de tu duda?</ListSubheader>
                {topics.map(({ route, name, source }, key) => (
                  <ListItemLink
                    to={`${url}/${route}`}
                    primary={name}
                    source={source}
                    listMarker={listMarker}
                    setListMarker={setListMarker}
                    keyMarker={key}
                    dark={dark}
                    setPrimary={setPrimary}
                    setSelectedTopic={setSelectedTopic}
                    listLength={topics.length}
                  />
                ))}
              </List>
            </div>
          </Card>
        </Grid>
        <Grid item md={8} xs={12}>
          <Card className={`p-2 ${topics === [] ? "pb-0" : "pb-4"}`}>
            <Route path={`${path}/:topicId`}>
              <Topic
                selectedTopic={selectedTopic}
                setSelectedTopic={setSelectedTopic}
                primaryName={primaryName}
                {...props}
              />
            </Route>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

const Faq = (props) => {
  return (
    <div>
      <FileBrowser {...props} />
    </div>
  );
};

Faq.propTypes = {};

const mapStateToProps = (state) => ({
  dark: state.dark,
});

export default connect(mapStateToProps, {})(Faq);
